import { EmailAssistantModal } from '@frontend/email-assistant-modal';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button, useModalControl } from '@frontend/design-system';
import { useContentComposer } from '../../content-composer/content-composer-provider';
import { emailAssistantGradientStyling } from '../../styles';
import { useEmailHeader } from './email-header-context';

export const EmailAssistantButton = () => {
  const { modalProps, triggerProps } = useModalControl();
  const { promptProps } = useContentComposer();
  const { subjectProps } = useEmailHeader();

  return (
    <>
      <Button
        variant='secondary'
        onClick={triggerProps.onClick}
        css={[
          emailAssistantGradientStyling,
          {
            padding: theme.spacing(0.625, 1),
            width: theme.spacing(5),
            border: '1px solid transparent',
          },
        ]}
      >
        <Icon name='aiassistant-small' />
      </Button>
      <EmailAssistantModal
        modalProps={modalProps}
        onComplete={(value: string) => subjectProps?.onChange({ ...subjectProps, value, name: 'subject' })}
        type='subject'
        previousText={subjectProps?.value}
        promptProps={promptProps}
      />
    </>
  );
};
